import { render, staticRenderFns } from "./index.vue?vue&type=template&id=2b8d889c&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/build/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2b8d889c')) {
      api.createRecord('2b8d889c', component.options)
    } else {
      api.reload('2b8d889c', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=2b8d889c&", function () {
      api.rerender('2b8d889c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/order/list/index.vue"
export default component.exports